/**
 * Public facade of the workspace module: the only path other modules may import
 * (`@/modules/workspace/public`). Composables, domain types and reusable components
 * go here; stores, API clients and views stay private.
 */
export { useWorkspaceLegalInfoForm, } from "./composables/useWorkspaceLegalInfoForm";
export { useSharedEmailSetting } from "./composables/useSharedEmailSetting";
export { SHARED_EMAIL_DISABLED_ERROR_CODE } from "./domain/entities/sharedEmailSetting";
export { ORGANIZATION_QUALIFICATION_MAX_LENGTH, RECEIPT_OBJECT_MAX_LENGTH, SIGNATORY_NAME_MAX_LENGTH, SIGNATURE_MAX_BYTES, } from "./composables/useWorkspaceSettingsValidation";
/** Route name of the workspace settings page, where the workspace identity is edited. */
export const WORKSPACE_SETTINGS_ROUTE_NAME = "WorkspaceSettings";
